







import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'TextInformation',
  props: {
    title: String,
    body: String,
  },
})
export default class TextInformation extends Vue {

}
